// サンプル例のモックデータ
export const mockExamples = [
  {
    name: "単位円",
    description: "中心が原点の半径1の円",
    coefficients: { A: 1, B: 0, C: 1, D: 0, E: 0, F: -1 }
  },
  {
    name: "標準楕円",
    description: "中心が原点の標準的な楕円",
    coefficients: { A: 4, B: 0, C: 1, D: 0, E: 0, F: -4 }
  },
  {
    name: "標準放物線",
    description: "y = x² の放物線",
    coefficients: { A: 1, B: 0, C: 0, D: 0, E: -1, F: 0 }
  },
  {
    name: "標準双曲線",
    description: "x² - y² = 1 の双曲線",
    coefficients: { A: 1, B: 0, C: -1, D: 0, E: 0, F: -1 }
  },
  {
    name: "回転した楕円",
    description: "45度回転した楕円",
    coefficients: { A: 5, B: 4, C: 8, D: 0, E: 0, F: -36 }
  },
  {
    name: "一般的な放物線",
    description: "x = y² の放物線",
    coefficients: { A: 0, B: 0, C: 1, D: -1, E: 0, F: 0 }
  },
  {
    name: "円（平行移動）",
    description: "中心が(2, 3)の半径2の円",
    coefficients: { A: 1, B: 0, C: 1, D: -4, E: -6, F: 9 }
  },
  {
    name: "退化した二次曲線",
    description: "二直線に退化した例",
    coefficients: { A: 1, B: 0, C: -1, D: 0, E: 0, F: 0 }
  }
];